import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import {grey} from '@drivesally/sally-ui/lib/libs/colors';

const Panel = styled.div`
  border: 1px solid ${grey};
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  margin-top: 10px;
  max-height: 168px;
  overflow: hidden;
`;

const Header = styled.div`
  align-items: center;
  border-bottom: 1px solid ${grey};
  display: flex;
  flex-shrink: 0;
  justify-content: space-between;
  padding: 8px 12px;
`;

const Title = styled.div`
  font-size: 13px;
  font-weight: 600;
`;

const RefreshButton = styled.button`
  background: none;
  border: none;
  color: #555;
  cursor: pointer;
  font-size: 12px;
  padding: 0;

  &:hover:not(:disabled) {
    text-decoration: underline;
  }

  &:disabled {
    cursor: default;
    opacity: 0.5;
  }
`;

const List = styled.div`
  overflow-y: auto;
`;

const SuggestionButton = styled.button`
  background: none;
  border: none;
  border-bottom: 1px solid ${grey};
  cursor: pointer;
  display: block;
  font-size: 13px;
  line-height: 1.4;
  padding: 8px 12px;
  text-align: left;
  white-space: pre-wrap;
  width: 100%;

  &:hover:not(:disabled) {
    background: ${grey};
  }

  &:disabled {
    cursor: default;
    opacity: 0.5;
  }

  &:last-child {
    border-bottom: none;
  }
`;

const EmptyState = styled.div`
  color: #888;
  font-size: 13px;
  padding: 12px;
`;

const CrmSuggestedReplyPicker = ({
  disabled,
  loading,
  onRefresh,
  onSelect,
  suggestions,
}) => {
  const renderContent = () => {
    if (loading) return <EmptyState>Loading suggestions...</EmptyState>;
    if (!suggestions.length)
      return <EmptyState>No suggestions available</EmptyState>;
    return suggestions.map((suggestion, index) => (
      <SuggestionButton
        key={index}
        type="button"
        disabled={disabled}
        onClick={() => onSelect(suggestion)}
      >
        {suggestion}
      </SuggestionButton>
    ));
  };

  return (
    <Panel>
      <Header>
        <Title>Suggested replies</Title>
        <RefreshButton
          type="button"
          disabled={loading || disabled}
          onClick={onRefresh}
        >
          Refresh
        </RefreshButton>
      </Header>
      <List>{renderContent()}</List>
    </Panel>
  );
};

CrmSuggestedReplyPicker.propTypes = {
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  onRefresh: PropTypes.func,
  onSelect: PropTypes.func,
  suggestions: PropTypes.array,
};

CrmSuggestedReplyPicker.defaultProps = {
  suggestions: [],
};

export default CrmSuggestedReplyPicker;
